/*
  This utility was ported to typescript from the original version of the node-moudle frame-rpc version 1.3.0
  since it was exported from that node module in a way that coud not be used on esNext moules. esNext must be
  used if you want to use lazy loaded modules in angular.
  https://www.npmjs.com/package/frame-rpc
 */

const has = (obj: any, prop: string) => {
  return obj.hasOwnProperty(prop);
};

const isarray = Array.isArray;

const VERSION = '1.0.0';

export class RPC {
  public src: Window;
  public dst: Window;
  public origin: string;

  private _sequence: number;
  private _callbacks: { [key: string]: any };
  private _destroyed: boolean = false;
  private _methods: { [key: string]: Function };
  private _onmessageHandlerBindedFunction: EventListenerOrEventListenerObject;

  constructor(src: Window, dst: Window, origin: string, methods?: any) {
    if (origin === '*') {
      this.origin = '*';
    } else {
      const uorigin = new URL(origin);
      this.origin = uorigin.protocol + '//' + uorigin.host;
    }

    this.src = src;
    this.dst = dst;

    this._sequence = 0;
    this._callbacks = {};

    this._onmessageHandlerBindedFunction = this._onmessage.bind(this);
    this.src.addEventListener('message', this._onmessageHandlerBindedFunction);
    this._methods = typeof methods === 'function'
      ? methods(this)
      : methods || {};
  }


  private _onmessage(ev: any) {
    if (this._destroyed) {
      return;
    }

    if (this.origin !== '*' && ev.origin !== this.origin) {
      return;
    }
    if (!ev.data || typeof ev.data !== 'object') {
      return;
    }
    if (ev.data.protocol !== 'frame-rpc') {
      return;
    }
    if (!isarray(ev.data.arguments)) {
      return;
    }

    this._handle(ev.data);
  }


  public destroy() {
    this._destroyed = true;
    this.src.removeEventListener('message', this._onmessageHandlerBindedFunction);
  }

  public call(method: string, ...args: any[]) {
    return this.apply(method, args);
  }

  public apply(method: string, args?: any[]) {
    if (this._destroyed) {
      return;
    }

    const seq = this._sequence++;
    if (typeof args[args.length - 1] === 'function') {
      this._callbacks[seq] = args[args.length - 1];
      args = args.slice(0, -1);
    }
    this.dst.postMessage({
      protocol: 'frame-rpc',
      version: VERSION,
      sequence: seq,
      method: method,
      arguments: args
    }, this.origin);
  }

  private _handle(msg: any) {
    if (this._destroyed) {
      return;
    }

    if (has(msg, 'method')) {
      if (!has(this._methods, msg.method)) {
        return;
      }

      const args = msg.arguments.concat(function() {
        this.dst.postMessage({
            protocol: 'frame-rpc',
            version: VERSION,
            response: msg.sequence,
            arguments: [].slice.call(arguments)
          },
          this.origin);
      }.bind(this));

      this._methods[msg.method].apply(this._methods, args);

    } else if (has(msg, 'response')) {

      const cb = this._callbacks[msg.response];
      delete this._callbacks[msg.response];
      if (cb) {
        cb.apply(null, msg.arguments);
      }
    }
  }
}

